import { UtilityService } from './index'

class PermissionService  {
    
    async listEmploye(page) {
        let result = await fetch(UtilityService.baseUrl() + 'api/employee/Employees', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body : JSON.stringify({
                page : page
            })
        });
        return { 
            status : result.status,
            text : await result.json()
        };
    }

    async searchEmploye(searchText) {
        let result = await fetch(UtilityService.baseUrl() + 'api/employee/searchEmployees', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body : JSON.stringify({
                searchText : searchText
            })
        });
        return { 
            status : result.status,
            text : await result.json()
        };
    }

    async listRoles(page) {
        let result = await fetch(UtilityService.baseUrl() + 'api/permission/roles', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body : JSON.stringify({
                page : page
            })
        });
        return { 
            status : result.status,
            text : await result.json()
        };
    }

    async updateRoleRights(obj) {
        let result = await fetch(UtilityService.baseUrl() + 'api/permission/updateRoleRights', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body : JSON.stringify(obj)
        });
        return {
            status : result.status,
            text : await result.json()
        } ;

    }

    async getRoleRights(_id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/permission/getRoleRights', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body : JSON.stringify({
               roleId : _id
            })
        });
        return {
            status : result.status,
            text : await result.json()
        } ;

    }

    async getRole(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/permission/getRoleName', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                roleId : id
            })
        });
        return {
            status : result.status,
            text : await result.json()
        } ;
    }    
    
    async createRole(role,description) {
        let result = await fetch(UtilityService.baseUrl() + 'api/permission/addRole', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                roleName: role,
                description: description
            })
        });
        return {
            status : result.status,
            text : await result.json()
        } ;
    }

    
    async editRole(id,role,description) {
        let result = await fetch(UtilityService.baseUrl() + 'api/permission/addRole', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id,
                roleName: role,
                description: description
            })
        });
        return {
            status : result.status,
            text : await result.json()
        } ;
    }
    
    async removeRole(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/permission/deleteRole', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            status : result.status,
            text : await result.json()
        } ;

    }

    async searchRoles (by,value,page){
        let result = await fetch(UtilityService.baseUrl() + 'api/permission/searchRoles', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                for: value,
                by: by,
                page : page 
            })
        });
        return {
            status : result.status,
            text : await result.json()
        };
    }

    async searchEmployeeList (by,value,page){
        let result = await fetch(UtilityService.baseUrl() + 'api/employee/searchEmployeesByKey', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                for: value,
                by: by,
                page : page 
            })
        });
        return {
            status : result.status,
            text : await result.json()
        };
    }


    async getEmploye(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/employee/employee', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id:id
            })
        });
        return {
            status : result.status,
            text : await result.json()
        };

    }
    
    async createEmploye(data) {

        let result = await fetch(UtilityService.baseUrl() + 'api/employee/addEmployee', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status : result.status,
            text : await result.json()
        };
    }
    
    async updateEmploye(data) {

        let result = await fetch(UtilityService.baseUrl() + 'api/employee/editEmployee', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status : result.status,
            text : await result.json()
        };

    }
        
    async removeEmploye(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/employee/Employee', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return { 
            status : result.status,
            text : await result.json()}
        ;

    }

    async updateRights(obj) {

        let api = obj.moduleName == "EMPLOYEE" ? "api/employee/updateEmployeeRights" : "api/permission/updateRoleRights"
        delete obj.moduleName 
        let result = await fetch(UtilityService.baseUrl() + api, {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body : JSON.stringify(obj)
        });
        return {
            status : result.status,
            text : await result.json()
        } ;

    }

    async getEmployeeRights(_id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/employee/EmployeeRights', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body : JSON.stringify({
                _id : _id
            })
        });
        return {
            status : result.status,
            text : await result.json()
        } ;

    }



}
export default new PermissionService();


// WEBPACK FOOTER //
// ./src/services/permission.service.js